export default {
  presenter: 'hala',
  title: 'Jak jsme měnili DNSSEC algoritmus u 150.000 domén',
  subtitle: 'mírně pokročilí',
  text: `
V r. 2008 jsme zavedli DNSSEC ve stejný den, kdy ho spustil registr CZ.NIC. Po 10 letech úspěšného
fungování bylo na čase opustit starý RSA/SHA algoritmus a přejít na moderní ECDSA. Jak jsme se s
tím poprali u 150.000 domén, abychom zajistili jejich nepřetržitý chod a validnost DNS záznamů a
neohrozili fungování podstatné části českého internetu?
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/hala-dnssec.js